import * as React from 'react';

/** Material UI Packages. */
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid2';

/** Internal Components. */
import SectionBox from 'shared/ui/GridBox';

import { PartnerForm } from './PartnerForm';
import { tradePartnerConfig } from 'data/tradePartnerConfig';

export default function PartnerInfo(props) {
    /** Get props from NewTradePartnerDialog.js and EditTradePartnerDialog.js. (Both components provide the same set of props) */
    const { tradePartnerForm, setTradePartnerForm, tradePartnerValidator, partnerTypeOptions, purpose, spacing } = props;

    const sectionHeight = purpose === 'edit' ? '400px' : '93%';
    const requiredSectionSx = { height: sectionHeight };
    const optionalSectionSx =
        purpose === 'edit'
            ? {
                  height: sectionHeight,
                  gap: '10px',
                  overflowY: 'auto',
                  '& > *': { flexShrink: 0 },
              }
            : { height: sectionHeight, gap: '15px' };

    return (
        <Grid container sx={{ p: 2.5, pt: 1.8, height: '100%' }} spacing={spacing}>
            <SectionBox title={'REQUIRED INFO'} size={6} sx={requiredSectionSx}>
                {tradePartnerConfig.map((inputConfig) => {
                    return (
                        inputConfig.mode.includes(purpose) &&
                        inputConfig.required && (
                            <PartnerForm
                                tradePartnerForm={tradePartnerForm}
                                setTradePartnerForm={setTradePartnerForm}
                                key={inputConfig.field}
                                inputObj={inputConfig}
                                purpose={purpose}
                                partnerTypeOptions={
                                    inputConfig.field === 'partner_type' ? partnerTypeOptions : undefined
                                }
                                validator={tradePartnerValidator}
                            />
                        )
                    );
                })}
            </SectionBox>
            <SectionBox title={'OPTIONAL INFO'} size={6} sx={optionalSectionSx}>
                {tradePartnerConfig.map((inputConfig) => {
                    return (
                        inputConfig.mode.includes(purpose) &&
                        !inputConfig.required && (
                            <PartnerForm
                                tradePartnerForm={tradePartnerForm}
                                setTradePartnerForm={setTradePartnerForm}
                                key={inputConfig.field}
                                inputObj={inputConfig}
                                purpose={purpose}
                                partnerTypeOptions={
                                    inputConfig.field === 'partner_type' ? partnerTypeOptions : undefined
                                }
                                validator={tradePartnerValidator}
                            />
                        )
                    );
                })}
            </SectionBox>
        </Grid>
    );
}
